import { render, staticRenderFns } from "./FeatureTypeEdit.vue?vue&type=template&id=6fef4975&scoped=true"
import script from "./FeatureTypeEdit.vue?vue&type=script&lang=js"
export * from "./FeatureTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeEdit.vue?vue&type=style&index=0&id=6fef4975&prod&lang=less"
import style1 from "./FeatureTypeEdit.vue?vue&type=style&index=1&id=6fef4975&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef4975",
  null
  
)

export default component.exports